import { Component, OnDestroy, OnInit, inject, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { IntegracaoParticipanteStatus } from '../../core/enum/integracao-participante-status.enum';
import { AdesaoIntegracaoFiltros } from '../../core/models/integracao.model';

export interface IntegracaoParticipanteStatusOption {
  value: string;
  label: string;
}

const DEBOUNCE_MS = 300;

@Component({
  selector: 'app-adesao-integracao-filter-bar',
  imports: [ReactiveFormsModule],
  templateUrl: './adesao-integracao-filter-bar.component.html',
  styleUrl: './adesao-integracao-filter-bar.component.scss',
})
export class AdesaoIntegracaoFilterBarComponent implements OnInit, OnDestroy {
  private readonly fb = inject(FormBuilder);

  readonly filtersChange = output<AdesaoIntegracaoFiltros>();

  readonly statusOptions: IntegracaoParticipanteStatusOption[] = [
    { value: 'todos', label: 'Todos' },
    { value: IntegracaoParticipanteStatus.Aguardando, label: 'Aguardando' },
    { value: IntegracaoParticipanteStatus.Sucesso, label: 'Sucesso' },
    { value: IntegracaoParticipanteStatus.Erro, label: 'Erro' },
  ];

  readonly form = this.fb.nonNullable.group({
    participante: '',
    status: 'todos',
    data: '',
  });

  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(debounceTime(DEBOUNCE_MS), takeUntil(this.destroy$))
      .subscribe(() => this.emitFilters());

    this.emitFilters();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private emitFilters(): void {
    const { participante, status, data } = this.form.getRawValue();
    const filtros: AdesaoIntegracaoFiltros = {};

    const termo = participante.trim();
    if (termo) {
      filtros.participante = termo;
    }

    if (status && status !== 'todos') {
      filtros.status = status;
    }

    if (data) {
      filtros.data = data;
    }

    this.filtersChange.emit(filtros);
  }
}
